export default "__VITE_ASSET__BGwY1cAg__ 430w";